import React, { useEffect, useState } from 'react';
import axios from 'axios';

const JobListings = () => {
  const [jobs, setJobs] = useState([]);
  const [originalJobs, setOriginalJobs] = useState([]);
  const [sortedJobs, setSortedJobs] = useState([]);
  const [sortOption, setSortOption] = useState('most-recent');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const jobsPerPage = 5;

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        'https://api.airportlogistics.org:9100/Career_API/v1.0/BAL_Careers/GetJobList'
      )
      .then((response) => {
        const list = response.data.JobListing || [];
        setJobs(list);
        setOriginalJobs(list);
        setSortedJobs(list);
      })
      .catch((error) => {
        console.error('Error fetching job listings:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    let sorted = [...jobs];

    switch (sortOption) {
      case 'location-asc':
        sorted.sort((a, b) =>
          a.JobLocationDetails?.localeCompare(b.JobLocationDetails)
        );
        break;
      case 'location-desc':
        sorted.sort((a, b) =>
          b.JobLocationDetails?.localeCompare(a.JobLocationDetails)
        );
        break;
      case 'oldest':
        sorted = [...originalJobs].reverse();
        break;
      case 'most-recent':
      default:
        sorted = [...originalJobs];
        break;
    }

    setSortedJobs(sorted);
    setCurrentPage(1);
  }, [sortOption, jobs, originalJobs]);

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = sortedJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(sortedJobs.length / jobsPerPage);

  return (
    <div className='job-listings'>
      <div className='sort-dropdown'>
        <label htmlFor='sort'>Sort By:</label>
        <select
          id='sort'
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          className='custom-select'
        >
          <option value='most-recent'>Most Recent</option>
          <option value='oldest'>Oldest</option>
          <option value='location-asc'>Location (A–Z)</option>
          <option value='location-desc'>Location (Z–A)</option>
        </select>
      </div>

      {loading ? (
        <div className='spinner'></div>
      ) : (
        <>
          {currentJobs.map((job, index) => (
            <div key={index} className='job-item'>
              <div className='job-left'>
                <h4 className='job-location-heading'>{job.jobTitle}</h4>
                <p className='job-location-sub'>
                  Location: {job.JobLocationDetails}
                </p>
              </div>
              <div className='job-right'>
                <a
                  href={job.InsperityLink}
                  target='_blank'
                  rel='noreferrer'
                  className='job-role-link'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='18'
                    height='14'
                    viewBox='0 0 18 14'
                    fill='none'
                  >
                    <g clipPath='url(#clip0_309_1935)'>
                      <path
                        d='M1 7H17M17 7L11 1M17 7L11 13'
                        stroke='#0082FC'
                        strokeWidth='2'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      ></path>
                    </g>
                    <defs>
                      <clipPath id='clip0_309_1935'>
                        <rect width='18' height='14' fill='white'></rect>
                      </clipPath>
                    </defs>
                  </svg>
                  Apply Now
                </a>
              </div>
            </div>
          ))}

          <div className='pagination'>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default JobListings;
